import router from "@/router";
import { pcRoutes, mobileRoutes } from "@/router"
import {isMobile} from "../../api/utils";

// 判断当前设备的型号从而改变当前路由
router.addRoute(isMobile() ? mobileRoutes[1] : pcRoutes[1]);
router.addRoute(isMobile() ? mobileRoutes[2] : pcRoutes[2]);
if (isMobile()) router.addRoute(mobileRoutes[3]);